<template>
  <div>
    <h4>いいねした投稿</h4>
    <h6 v-if="favposts.length === 0">いいねした投稿がありません</h6>
    <div v-else>
      <div style="margin-bottom: 15px;">
        <b-card-group deck>
          <div class="kowai" v-for="(post, index) in favposts" :key="index">
            <b-card style="background-color: olivedrab;" text-variant="white" header="Book" class="text-center">
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本の名前</p>
                <h4>{{post.title}}</h4>
              </div>
              <p class="mt-2">オススメ度: {{ post.recommend }}</p>
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本のタイプ</p>
                <b-card-text style="font-size: 14px;">{{post.type}}</b-card-text>
              </div>
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">メモ</p>
                <b-card-text>{{post.comment}}</b-card-text>
              </div>
            </b-card>
          </div>
        </b-card-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    favposts() {
      const arr = this.$store.state.myfavs
      return arr.sort(function(a,b) {
          return (a.createdAt < b.createdAt ? 1 : -1);
      });
    }
  },
  created() {
    this.$store.dispatch('getGoods')
  }
}
</script>

<style scoped>
.text-white{
  width: 75%;
  margin: auto;
}

.kowai{
  margin-bottom: 20px;
}
</style>